import type { CommonData } from "../types/common";

export const getLatestStatisticaVariables = (data: CommonData): void => {
  if (!data) {
    return;
  }

  const statistica = data?.integrations?.statistica;
  if (!statistica) {
    return;
  }

  const { SE_External, FI_External } = statistica;
  if (SE_External?.latest) {
    // Set latest SE_External data
    statistica.SE_External = SE_External.latest;
  }
  if (FI_External?.latest) {
    // Set latest FI_External data
    statistica.FI_External = FI_External.latest;
  }
};
